import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, ButtonGroup, Col, Label, Row} from 'reactstrap';
import {AvField, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IRootState} from 'app/shared/reducers';
import {createEntity, getEntity, reset, updateEntity} from './condition.reducer';
import {getEntities as getFollowups} from '../followup/followup.reducer';

export interface IConditionUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {
}

export const ConditionUpdate = (props: IConditionUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);
  const [countryId, setCountryId] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [activeStatus, setActiveStatus] = useState(true);
  const [deliveredStatus, setDeliveredStatus] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState('');
  const [selectedFollowupType, setSelectedFollowupType] = useState('MATERNAL');
  const [selectedEmergencyType, setSelectedEmergencyType] = useState('ANTEPARTUM');
  const {conditionEntity, loading, updating} = props;

  const handleClose = () => {
    props.history.push('/condition');
  };

  useEffect(() => {
    if (isNew) {
      const params = new URLSearchParams(props.location.search);
      const cid = params.get('country_id');
      setCountryId(cid);
      setSelectedCountryId(cid);
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
    props.getFollowups();
  }, []);

  useEffect(() => {
    if (!isNew && conditionEntity?.id) setActiveStatus(conditionEntity?.isActive);
  }, [conditionEntity]);

  useEffect(() => {
    if (!isNew && conditionEntity?.followupType) setSelectedFollowupType(conditionEntity.followupType);
    if (!isNew && conditionEntity?.emergencyType) setSelectedEmergencyType(conditionEntity.emergencyType);
    if (!isNew && conditionEntity?.countryId) setSelectedCountryId(conditionEntity.countryId);
    if (!isNew) setSelectedParentId(conditionEntity?.parentId || '');
  }, [conditionEntity]);

  useEffect(() => {
    if (!isNew && conditionEntity?.id) setDeliveredStatus(conditionEntity?.isDelivered);
  }, [conditionEntity]);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const cid = isNew ? countryId : conditionEntity.countryId;
      const country = props.countries.find(c => c.id === cid);
      const entity = {
        ...conditionEntity,
        ...values,
        isActive: activeStatus,
        isAlive: false,
        isDelivered: deliveredStatus,
        parentId: selectedParentId || null,
        // country
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="mmamaApp.condition.home.createOrEditLabel">Create or edit a Condition</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : conditionEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="condition-id">ID</Label>
                  <AvInput id="condition-id" type="text" className="form-control" name="id" required readOnly/>
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="activeStatusLabel">
                  Active Status
                </Label>
                <ButtonGroup style={{marginLeft: '30px'}}>
                  <Button
                    color={activeStatus ? 'primary' : 'secondary'}
                    value={activeStatus}
                    onClick={e => {
                      setActiveStatus(true);
                    }}
                  >
                    Active
                  </Button>

                  <Button
                    color={!activeStatus ? 'primary' : 'secondary'}
                    value={activeStatus}
                    onClick={() => {
                      setActiveStatus(false);
                    }}
                  >
                    Inactive
                  </Button>
                </ButtonGroup>
              </AvGroup>
              <AvGroup>
                <Label id="isDeliveredLabel">
                  Is Delivered
                </Label>
                <ButtonGroup style={{marginLeft: '30px'}}>
                  <Button
                    color={deliveredStatus === true ? 'primary' : 'secondary'}
                    value={deliveredStatus}
                    onClick={e => {
                      setDeliveredStatus(true);
                    }}
                  >
                    Yes
                  </Button>

                  <Button
                    color={deliveredStatus === false ? 'primary' : 'secondary'}
                    value={deliveredStatus}
                    onClick={() => {
                      setDeliveredStatus(false);
                    }}
                  >
                    No
                  </Button>
                </ButtonGroup>
              </AvGroup>
              <AvGroup>
                <Label id="conditionTypeLabel" for="condition-emergencyType">
                  Condition Type
                </Label>
                <AvInput
                  id="condition-emergencyType"
                  type="select"
                  className="form-control"
                  name="followupType"
                  value={selectedFollowupType}
                  onChange={e => setSelectedFollowupType(e.target.value)}
                >
                  <option value="MATERNAL">MATERNAL</option>
                  <option value="NEONATAL">NEONATAL</option>
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label id="emergencyTypeLabel" for="emergencyType">
                  Emergency Type
                </Label>
                <AvInput
                  id="emergencyType"
                  type="select"
                  className="form-control"
                  name="emergencyType"
                  value={selectedEmergencyType}
                  onChange={e => setSelectedEmergencyType(e.target.value)}
                >
                  <option value="ANTEPARTUM">ANTEPARTUM</option>
                  <option value="LABOUR">LABOUR</option>
                  <option value="POSTPARTUM">POSTPARTUM</option>
                  <option value="NEONATAL">NEONATAL</option>
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label id="enConditionLabel" for="condition-enCondition">
                  Condition (English)
                </Label>
                <AvField
                  id="condition-enCondition"
                  type="text"
                  name="enFollowup"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="stConditionLabel" for="condition-stCondition">
                  Condition (Local Language)
                </Label>
                <AvField
                  id="condition-stCondition"
                  type="text"
                  name="stFollowup"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>
              {props.countries && props.countries.length > 0 && (
                <AvGroup>
                  <Label for="condition-country">Country</Label>
                  <AvInput
                    id="condition-country"
                    type="select"
                    className="form-control"
                    name="countryId"
                    value={selectedCountryId || ''}
                    onChange={e => setSelectedCountryId(e.target.value)}
                  >
                    {props.countries
                      ? props.countries.map(country => (
                        <option value={country.id} key={country.id}>
                          {country.name}
                        </option>
                      ))
                      : null}
                  </AvInput>
                </AvGroup>
              )}
              <AvGroup>
                <Label for="condition-parentId">Parent Followup (optional)</Label>
                <AvInput
                  id="condition-parentId"
                  type="select"
                  className="form-control"
                  name="parentId"
                  value={selectedParentId}
                  onChange={e => setSelectedParentId(e.target.value)}
                >
                  <option value="">-- None --</option>
                  {props.followupList
                    ? props.followupList
                        .filter(f =>
                          f.followupType === selectedFollowupType
                          && f.emergencyType === selectedEmergencyType
                          && f.countryId === selectedCountryId
                          && f.isAlive === false)
                        .map(followup => (
                      <option value={followup.id} key={followup.id}>
                        {followup.enFollowup}
                      </option>
                    ))
                    : null}
                </AvInput>
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/condition" replace color="info">
                <FontAwesomeIcon icon="arrow-left"/>
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save"/>
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  conditionEntity: storeState.condition.entity,
  loading: storeState.condition.loading,
  updating: storeState.condition.updating,
  updateSuccess: storeState.condition.updateSuccess,
  countries: storeState.authentication.countries,
  followupList: storeState.followup.followupList,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
  getFollowups,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ConditionUpdate);
